import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
  
  currentYear = new Date().getFullYear();
  
  footerData = {
    companyName: 'QuadProSol',
    links: [
      { text: 'About Us', href: '/about' },
      { text: 'Schedule Appointment', href: '/scheduling' },
      { text: 'Complete Intake', href: '/intake' }
    ],
    websiteCredit: 'B2B'
  };

  constructor(
    private router: Router
  ) {
    // Theme toggle disabled for now
  }

  /**
   * Handle footer link clicks
   */
  onLinkClick(event: Event, link: any): void {
    event.preventDefault();

    if (link.href === '/about.html') {
      window.location.href = link.href;
      return;
    }

    this.router.navigate([link.href]);
  }

}
